import { useQuery } from '@tanstack/react-query'

import { useAppSelector } from 'common/hooks/redux'

import { fetchLanguageRules } from '../api'
import { languageRulesKeys } from '../queryKeys'

const useGetLanguageRulesQuery = () => {
  const accountId = useAppSelector((state) => state.authStates.accountId)

  return useQuery({
    queryKey: languageRulesKeys.list(accountId),
    queryFn: () => fetchLanguageRules({ accountId }),
    staleTime: 1000 * 60 * 1,
  })
}

export default useGetLanguageRulesQuery
